<template>
  <div class="privacy" @click="$emit('click')">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'privacyTitle'
}
</script>
<style lang="less" scoped>
.privacy {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #C4C4C4;
  margin-top: 40px;
  margin-bottom: 20px;
  text-decoration-line: underline;
}
</style>
